export const state = {
    isShown: true,
    hasShadow: false,
    hasLogo: false,
    currentPage: ''
};